module.exports = __webpack_public_path__ + "img/form-image.4104c172.png";